/**
 * Portal record classification for real-estate leads owned by a customer.
 * Buckets are mutually exclusive.
 *
 * - customer: converted / won / customer statuses
 * - client: status named Client, OR registered via portal (no office Created_By)
 * - lead: office-assigned records that are not yet customers
 */

const CUSTOMER_STATUS_KEYWORDS = ["convert", "customer", "won", "closed won", "success"];
const CLIENT_STATUS_KEYWORDS = ["client"];

function normalizeStatus(status) {
  return String(status || "").trim().toLowerCase();
}

export function isCustomerStatus(status) {
  const s = normalizeStatus(status);
  if (!s) return false;
  return CUSTOMER_STATUS_KEYWORDS.some((k) => s.includes(k));
}

export function isClientStatus(status) {
  const s = normalizeStatus(status);
  if (!s || isCustomerStatus(s)) return false;
  return CLIENT_STATUS_KEYWORDS.some((k) => s.includes(k));
}

function isPortalRegistered(row) {
  const createdBy = row?.Created_By ?? row?.created_by;
  return createdBy == null || createdBy === "";
}

/**
 * Classify a portal lead row into one of: "lead" | "client" | "customer".
 */
export function classifyPortalLead(row) {
  const status = row?.Lead_Status ?? row?.lead_status ?? row?.Status ?? row?.status;
  if (isCustomerStatus(status)) return "customer";
  if (isClientStatus(status) || isPortalRegistered(row)) return "client";
  return "lead";
}

export function countPortalLeadBuckets(rows) {
  const out = { leads: 0, clients: 0, customers: 0 };
  for (const row of Array.isArray(rows) ? rows : []) {
    const bucket = classifyPortalLead(row);
    if (bucket === "customer") out.customers += 1;
    else if (bucket === "client") out.clients += 1;
    else out.leads += 1;
  }
  return out;
}
